import { Log } from '@/shared/Log';

/**
 * Calculate BMI (Body Mass Index)
 * @param heightCm - Height in centimeters
 * @param weightKg - Weight in kilograms
 * @returns BMI as a number rounded to 1 decimal, or null if calculation fails
 */
export function calculateBMI(
    heightCm: number,
    weightKg: number,
): number | null {
    try {
        if (typeof heightCm !== 'number' || typeof weightKg !== 'number') {
            Log.warn('Height and weight must be numbers', {
                height: heightCm,
                weightKg,
            });
            return null;
        }

        if (heightCm <= 0 || weightKg <= 0) {
            Log.warn('Height and weight must be positive numbers', {
                height: heightCm,
                weightKg,
            });
            return null;
        }

        const heightM = heightCm / 100;
        const bmi = weightKg / (heightM * heightM);

        if (!isFinite(bmi)) {
            Log.warn('BMI calculation resulted in an invalid number', {
                height: heightCm,
                weightKg,
                bmi,
            });
            return null;
        }

        return parseFloat(bmi.toFixed(1)); // removes trailing zeros
    } catch (err) {
        Log.warn('Unexpected error during BMI calculation', {
            height: heightCm,
            weightKg,
            error: err,
        });
        return null;
    }
}
